var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7792 13.2591L17.3493 9.6369H13.7831V7.28738C13.7831 6.2962 14.2804 5.32946 15.8776 5.32946H17.5V2.24572C17.5 2.24572 16.0283 2.00098 14.6219 2.00098C11.6836 2.00098 9.76486 3.73617 9.76486 6.87622V9.6369H6.5V13.2591H9.76486V22.0159C10.4203 22.1163 11.0909 22.1676 11.774 22.1676C12.4571 22.1676 13.1277 22.1163 13.7831 22.0159V13.2591H16.7792Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/Fb.79fa435af61d43cc222aefb5b784feb8.svg";
export { ForwardRef as ReactComponent };